// import { PaidInvoices } from 'src/app/models/response/artistoverlaydashboard.model';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService, ResponseObject } from './auth.service';
import { ServiceBase } from './service.base';
import {   StripePlans, Subscription } from '../models/stripe.model';

@Injectable({
  providedIn: 'root',
})

export class StripeService extends ServiceBase {
  private api: string = '/Stripe';

  constructor(private http: HttpClient, authService: AuthService) {
    super(authService);
  }

  public upgradePro(): Observable<any> {
    var httpOptions = this.RequestHeaders();

    const method: string = '/upgrade';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.post<any>(url, {}, httpOptions);
  }

  public getUserInvoice(): Observable<UserInvoiceResponse> {
    var httpOptions = this.RequestHeaders();

    const method: string = '/invoices';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<UserInvoiceResponse>(url, httpOptions);
  }

  public getAllPlans(): Observable<StripePlans[]> {
    var httpOptions = this.RequestHeaders();

    const method: string = '/fetchAllPlans';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<StripePlans[]>(url, httpOptions);
  }


  public getUserSubscription(): Observable<Subscription[]> {
    var httpOptions = this.RequestHeaders();

    const method: string = '/fetchMySubscription';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<Subscription[]>(url, httpOptions);
  }

  // public getAllSubscriptions(DurationDays: number): Observable<PaidInvoices> {
  //   var httpOptions = this.RequestHeaders();

  //   const method: string = '/fetchPaidInvoiceMonthWise/' + DurationDays;
  //   const url: string = environment.BASE_API_PATH + this.api + method;
  //   return this.http.get<PaidInvoices>(url, httpOptions);
  // }


  public cancelSubscription(subscriptionId: string): Observable<ResponseObject> {
    var httpOptions = this.RequestHeaders();

    const method: string = '/CancelCurrentSubscription/' + subscriptionId;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.post<ResponseObject>(url,{}, httpOptions);
  }

  public checkoutCompleted(sessionId: string): Observable<ResponseObject> {
    var httpOptions = this.RequestHeaders();
    const method: string = '/subscription-session-checkout-completed/' + sessionId
    // const method: string = '/' + sessionId + '/checkout-completed';
    const url: string = environment.BASE_API_PATH + this.api + method;
    var postObservable = this.http.post<ResponseObject>(url, {}, {
      headers: httpOptions.headers,
      withCredentials: true,  //this is important to pass the refresh-token cookie in the request headers
      //observe: 'response'   //if we don't observe the response, it would mean response would only contain body, not headers but we need headers to store the cookie returned as "set-cookie" header in the response
    });

    const subject = new ReplaySubject<ResponseObject>(1);
    subject.subscribe((response: ResponseObject) => {
      if (response.Success && response.ResponseData) {
        var accessToken: string = response.ResponseData;
        //update the access token in localStorage so the user sees that he has been upgraded to a pro account successfully
        this.authService.setAccessToken(accessToken);
      }
    }, (error) => { console.error(error); });
    postObservable.subscribe(subject);
    return subject;
  }

  public upgradeAccountPro(planId: string,currency: string,): Observable<ResponseObject> {
    var httpOptions = this.RequestHeaders();
  
    const method: string = '/upgradeWithSubscription';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.post<ResponseObject>(url, { planId:planId,currency:currency }, httpOptions);
  }
}

export class UserInvoiceResponse {
  InvoiceNumber?: string;
  CustomerName?: string;
  CustomerEmail?: string;
  AmountPaid?: number;
  IsPaid?: boolean;
  InvoicePdfUrl?: string;
  Status?: string;
  PaidAt?: Date;
  CustomerAddress?: string;
}
